import { useContext, useEffect } from 'react';

import styled from '@emotion/styled';

import useViewBusinessProfile from '../../../hooks/dashboard/kyc-compliance/useViewBusinessProfile';
import TableSliderContentWrapper from '../TableAccessories/TableSliderContentWrapper';
import { TableContext } from '../TableContext';

interface ViewCompanyProfileProps {
  data?: Record<string, any>;
}

const ViewCompanyProfile: React.FC<ViewCompanyProfileProps> = ({ data }) => {
  const { viewBusinessProfile, loading, businessProfileData } =
    useViewBusinessProfile();
  const tableContext = useContext(TableContext);

  useEffect(() => {
    if (tableContext?.showTableSlide) {
      viewBusinessProfile(data?.id);
    }

    // eslint-disable-next-line
  }, [data]);

  return (
    <TableSliderContentWrapper
      label={businessProfileData?.name ?? ''}
      loading={loading}
    >
      {/* section 1 */}
      <Section>
        <HeadTag>Business Details</HeadTag>
        <Cell>
          <CellLabel>Business registration number</CellLabel>
          <div>{businessProfileData?.registrationNumber ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Company email address</CellLabel>
          <div>{businessProfileData?.email ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Company phone no</CellLabel>
          <div>
            {businessProfileData?.phoneNumber
              ? `${'+' + businessProfileData?.phoneNumber}`
              : ''}
          </div>
        </Cell>
        <Cell>
          <CellLabel>Account role type</CellLabel>
          <div>{businessProfileData?.accountRole ?? ''}</div>
        </Cell>
      </Section>

      {/* section 2 */}
      <Section>
        <HeadTag>Logistic Details</HeadTag>
        <Cell>
          <CellLabel>Fleet size</CellLabel>
          <div>{businessProfileData?.fleetSize ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Typical route</CellLabel>
          <div>{businessProfileData?.typicalRoute ?? ''}</div>
        </Cell>
        <Cell>
          <CellLabel>Delivery vehicle type(s)</CellLabel>
          <VehicleTypesGroup>
            {businessProfileData?.fleetTypes?.map((type: string) => (
              <VehicleTypes key={type}>{type}</VehicleTypes>
            ))}
          </VehicleTypesGroup>
        </Cell>
      </Section>
    </TableSliderContentWrapper>
  );
};

export default ViewCompanyProfile;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* border: 1px solid red; */
`;

const HeadTag = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  padding: 10px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  margin-bottom: -8px;
`;

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  padding: 12px;
  color: #2f3644;
  background-color: rgba(250, 250, 250, 0.8);
`;

const CellLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrayText};
  /* border: 1px solid blue; */
`;

const VehicleTypesGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const VehicleTypes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background-color: rgba(91, 145, 245, 0.05);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
`;
